import type { SortingState } from '@tanstack/react-table';

export type ReturnsTimeframeId = '1Y' | '5Y';

export function getReturnsTimeframeFromSorting(
  sorting: SortingState,
  columnIds: { oneYear: string; fiveYear: string },
  fallback: ReturnsTimeframeId = '5Y',
): ReturnsTimeframeId {
  const columnId = sorting[0]?.id;

  if (columnId === columnIds.oneYear) {
    return '1Y';
  }

  if (columnId === columnIds.fiveYear) {
    return '5Y';
  }

  return fallback;
}

export function syncSortingToReturnsTimeframe(
  sorting: SortingState,
  timeframe: ReturnsTimeframeId,
  columnIds: { oneYear: string; fiveYear: string },
): SortingState {
  const activeSort = sorting[0];

  if (!activeSort) {
    return sorting;
  }

  if (
    activeSort.id !== columnIds.oneYear &&
    activeSort.id !== columnIds.fiveYear
  ) {
    return sorting;
  }

  return [
    {
      ...activeSort,
      id: timeframe === '1Y' ? columnIds.oneYear : columnIds.fiveYear,
    },
    ...sorting.slice(1),
  ];
}
